export default __webpack_public_path__ + "static/media/proximanova-bold-webfont.f96e7968.woff";